import { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import SVGIcon from '@components/SVGIcon.tsx'
import RatingWebApi from '@api/rating_web_api.js'

export default class Rating extends Component {
  static propTypes = {
    timeline: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  }

  constructor(props) {
    super(props)
    this.state = {
      ratingValue: null,
      ratingError: null,
    }
  }

  registerRating = value => {
    const { timeline } = this.props
    const timelineId = timeline.id
    // optimistic UI
    this.setState(
      {
        ratingValue: value,
      },
      () => {
        RatingWebApi.create(timelineId, value).then(
          res => {
            if (res.status == 200) {
              // all good
            } else {
              this.setState({
                ratingError: res.data.message,
              })
            }
          },
          err => {
            const response = err.response
            console.log(response.message)
          }
        )
      }
    )
  }

  handleUpClick = e => {
    this.registerRating(1)
  }

  handleDownClick = e => {
    this.registerRating(0)
  }

  render() {
    const { ratingValue } = this.state
    const upClassNames = classnames('rating__button', 'qa-upvote', { 'rating__button--active': ratingValue === 1 })
    const upvoteLabel = 'Upvote'
    const downClassNames = classnames('rating__button', 'qa-downvote', { 'rating__button--active': ratingValue === 0 })
    const downvotelabel = 'Downvote'
    return (
      <div className="rating">
        <div
          role="button"
          aria-label={upvoteLabel}
          title={upvoteLabel}
          className={downClassNames}
          onClick={this.handleDownClick}
        >
          <SVGIcon alt="Thumb up" pointerEvents="none" className="no-fill" xlinkHref="#streamline-like-1" />
        </div>
        <div
          role="button"
          aria-label={downvotelabel}
          title={downvotelabel}
          className={upClassNames}
          onClick={this.handleUpClick}
        >
          <SVGIcon alt="Thumb down" pointerEvents="none" className="no-fill" xlinkHref="#streamline-dislike-1" />
        </div>
      </div>
    )
  }
}
